/* ═══ NADA SE ANIMA FUERA DE PANTALLA ══════════════════════════════════════
   paco, en su iPhone 17 Pro: «iba fluido pero sí calentó mucho mi teléfono».
   Fluido y caliente a la vez no es falta de velocidad: es trabajo continuo que
   nadie está mirando. Una animación `infinite` mantiene despierto al compositor
   para siempre, aunque su sección esté veinte pantallas más arriba.

   🔴 MEDIDO en la portada, a 390 px con la CPU frenada 4×, comparando la página
   contra sí misma con las infinitas apagadas al vuelo:

       en reposo, sin tocar nada .....  77 cuadros / 2.5 s
       con las infinitas apagadas .... 123 cuadros / 2.5 s   (+60%)

   O sea: **el 40% de la capacidad del teléfono se iba en dibujar cosas que no
   se veían.** Eso es exactamente lo que se siente como calor.

   Este archivo no apaga nada: lo PAUSA mientras no se ve, y lo devuelve intacto
   en cuanto entra. `animation-play-state` conserva la posición, así que la luz
   no salta ni el carrusel se rebobina: continúan donde iban. Visualmente no
   cambia un solo fotograma de lo que alguien llega a ver.

   Se buscan solas —cualquier elemento cuyo `animation-iteration-count` sea
   `infinite`— para que esto siga funcionando cuando alguien añada la cuarta sin
   acordarse de este archivo. Hoy son tres: la luz del hero (`deriva`), el ancla
   que respira (`respira`) y la tira de YouTube (`desfila`).

   El margen de 200 px es a propósito: la animación arranca un pelo antes de
   asomar, así nadie ve el instante en que empieza a moverse.               */
(() => {
  if (!('IntersectionObserver' in window)) return;

  const vivas = [...document.querySelectorAll('*')].filter(e => {
    const s = getComputedStyle(e);
    return s.animationName !== 'none' && s.animationIterationCount.includes('infinite');
  });
  if (!vivas.length) return;

  const io = new IntersectionObserver(entradas => {
    for (const e of entradas) e.target.style.animationPlayState = e.isIntersecting ? '' : 'paused';
  }, { rootMargin: '200px' });

  vivas.forEach(e => { e.style.animationPlayState = 'paused'; io.observe(e); });

  /* Y con la pestaña en segundo plano se para todo. Aquí el navegador ya frena
     el rAF, pero NO las animaciones de CSS del compositor: una pestaña olvidada
     en el bolsillo seguiría gastando batería. */
  document.addEventListener('visibilitychange', () => {
    const oculto = document.visibilityState === 'hidden';
    vivas.forEach(e => { if (oculto) e.style.animationPlayState = 'paused'; });
    if (!oculto) vivas.forEach(e => io.unobserve(e) || io.observe(e));
  });
})();
